import React, { Component } from "react";
import styles from "./index.module.scss";

export default class Index extends Component {
  render() {
    const { style, info } = this.props;
    return (
      <div className={styles.product_title} style={style}>
        <div className={styles.title}>{info.name}</div>
        <div className={styles.tips}>{`${info.tips.slice(0, 15)}${info.tips.length > 15 ? '...' : ''}`}</div>
      </div>
    );
  }
}
